import { SingleNodeInstance, NodeInstance, DataValue, Vector, FunctionPortDefinition } from '@glueapp/graph-types';
import { NODE_LIBRARY_DICTIONARY } from './nodeLibrary';

export function createSingleNodeInstance(
    id: number,
    nodeId: string,
    position: Vector = { x: 0, y: 0 },
    selected: boolean = false,
    portValues: { [key: string]: DataValue } = {},
): SingleNodeInstance {
    const node = NODE_LIBRARY_DICTIONARY[nodeId];
    if (!node) {
        throw new Error(`Can't find node with id: ${nodeId}`);
    }
    return {
        id: id,
        nodeId,
        position,
        selected,
        portValues,
        inPorts: node.inPorts,
        outPorts: node.outPorts,
        portUserDefinedTypes: {},
        width: undefined,
        height: undefined,

        selectedVariable: undefined,
        state: {},
    };
}

export function createFunctionNodeInstance(
    nodeId: number,
    functionId: string,
    functionName: string,
    inputPortDefinitions: any[],
    outputPortDefinitions: any[],
    position: { x: number; y: number },
): NodeInstance {
    return {
        id: nodeId,
        nodeId: 'function',
        functionId: functionId,
        inPorts: inputPortDefinitions.map(portDef => ({
            name: portDef.name,
            type: portDef.type,
            optional: portDef.optional,
        })),
        outPorts: outputPortDefinitions.map(portDef => ({
            name: portDef.name,
            type: portDef.type,
            optional: portDef.optional,
        })),
        selected: false,
        portValues: {},
        portUserDefinedTypes: {},
        state: { functionName },
        position: position,
    };
}

export function createFunctionDefinition(
    functionId: string,
    functionName: string,
    centerCoordinate: number,
    inputPortDefinitions: FunctionPortDefinition[] = [],
    outputPortDefinitions: FunctionPortDefinition[] = [],
) {
    const functionInputsNodeId = 1;
    const functionOutputsNodeId = 2;
    const nodeSpacing = 1000;

    return {
        id: functionId,
        name: functionName,
        description: '',
        nodeInstances: [
            {
                id: functionInputsNodeId,
                nodeId: 'function-inputs',
                inPorts: [],
                outPorts: inputPortDefinitions.map(def => ({
                    name: def.name,
                    type: def.type,
                    optional: def.optional || false,
                })),
                selected: false,
                portValues: {},
                portUserDefinedTypes: {},
                state: {},
                position: { x: centerCoordinate - nodeSpacing / 2, y: centerCoordinate },
            },
            {
                id: functionOutputsNodeId,
                nodeId: 'function-outputs',
                inPorts: outputPortDefinitions.map(def => ({
                    name: def.name,
                    type: def.type,
                    optional: def.optional || false,
                })),
                outPorts: [],
                selected: false,
                portValues: {},
                portUserDefinedTypes: {},
                state: {},
                position: { x: centerCoordinate + nodeSpacing / 2, y: centerCoordinate },
            },
        ],
        connections: [],
        inputPortDefinitions,
        outputPortDefinitions,
        functionInputsNodeId,
        functionOutputsNodeId,
        createdAt: new Date(),
        updatedAt: new Date(),
        version: 1,
    };
}
